import {cssTheme} from '../v2/theme'
import {css} from '../theme/css'

export const linkButton = css`
  color: ${cssTheme.default.day.controlText} !important;
`
